import {
  Component, EventEmitter, OnChanges,
  OnInit, Output, SimpleChanges,
} from '@angular/core';
import {Input} from "@angular/core";


@Component({
  selector: 'app-button',
  templateUrl: './app-button.component.html',
  styleUrls: ['./app-button.component.scss']
})
export class AppButtonComponent implements OnInit, OnChanges {

  @Input() label: string = 'Weiter';
  @Input() icon: string = 'pi pi-arrow-right';
  @Input() tooltip: string | undefined;
  @Input() iconPos: 'left' | 'right' = 'right';
  @Input() disabled: boolean | undefined;
  @Input() severity: string | undefined;
  @Input() type: 'button' |  'submit' | 'reset' = 'button';
  @Input() showSpinner: boolean = true;
  @Input() outlined: boolean = false;
  @Input() busy: boolean | undefined;
  @Input() showIcon: boolean | undefined;
  @Input() showLabel: boolean = true;
  @Input() class: string | undefined;


  @Output() onClick = new EventEmitter<boolean>;

  uiIcon: string = '';
  initialized: boolean | undefined;

  constructor() {
  }

  ngOnInit() {
    this.refreshComponent();
  }

  refreshComponent() {

    if (!this.showIcon) {
      this.icon = '';
    }

    if (!this.showLabel) {
      this.label = '';
    }

    this.uiIcon = this.icon;

    this.initialized = true;
  }

  handleButtonClick() {

    if (this.busy) {
      return;
    }

    setTimeout(() => {
      this.handleBusyState();
    }, 500);

    this.onClick.emit(this.busy);

  }

  ngOnChanges(changes:SimpleChanges) {
    if (changes["busy"]) {
      this.handleBusyState();
    }
  }

  handleBusyState() {
    if (this.showSpinner) {
      if (this.busy) {
        this.uiIcon = 'pi pi-spin pi-spinner';
      } else {
        this.uiIcon = this.icon;
      }
    }
  }

}
